export const CURRENCY_LABEL = {
  'CNY': '¥',
  'HKD': 'HK$',
  'USD': '$'
}